export const OfferDtoDescriptions = {
  id: "Server-generated. Read-only.",
  variationId: "References the parent variation this offer belongs to.",
  enabled:
    "Whether the offer is actively applying discounts to customers on the storefront.",
  isTest:
    "When true, the offer exists in draft mode and is not applied to customers.",
  isArchived: "Whether the offer has been archived and is no longer active.",
  name: "Internal label for identifying the offer in dashboards.",
  unitType:
    "Threshold basis for tiered discounts: per-item quantity or monetary amount spent.",
  discountType:
    "How the discount value is calculated (e.g., percentage off, fixed amount off).",
  tiers:
    "Volume discount tiers ordered by threshold ascending (e.g., buy 2 = 10% off, buy 3 = 15% off).",
  maximumDollarDiscount:
    "Hard cap on the total dollar discount. Null means no cap is applied.",
  discountApplicationType:
    "Core discount mechanic (tiered volume, flat cart-level, gift-with-purchase, or free shipping).",
  discountApplicationMethod:
    "Whether the discount applies per individual item or to the entire order.",
  combinesWithIntelligems:
    "Whether this offer stacks with other active Intelligems discounts.",
  combinesWithShopify:
    "Whether this offer stacks with native Shopify discount codes.",
  shouldRejectCodes:
    "When true, manual discount codes entered at checkout are rejected while this offer is active.",
  shippingDiscount:
    "Shipping discount details. Only present when discountApplicationType is freeShipping.",
  requireSameItem:
    "For tiered discounts: when true, only multiples of the same product count toward thresholds.",
  subscriptionApplicationType:
    "Controls which purchase types this offer applies to: 'oneTime' (one-time purchases only), 'firstSub' (first subscription orders only), or 'oneTimeAndFirstSub' (both one-time and first subscription orders).",
} as const;

export const CreateOfferDtoDescriptions = {
  enabled: "Set to true to apply the discount to customers.",
  isTest:
    "Set to true to keep the offer in draft mode without applying to customers.",
  name: "Internal label shown in admin dashboards.",
  unitType:
    "Threshold basis for tiered discounts: item quantity or monetary amount spent.",
  discountType:
    "How the discount value is calculated (percentage off or fixed amount off).",
  tiers:
    "Volume discount tiers ordered by threshold ascending. Required when using tiered discounts.",
  maximumDollarDiscount: "Cap on maximum dollar discount. Null means no cap.",
  discountApplicationType:
    "Core discount mechanic (tiered volume, flat cart-level, gift-with-purchase, or free shipping).",
  discountApplicationMethod:
    "Whether the discount applies per individual item or to the entire order.",
  combinesWithIntelligems:
    "Set to true to allow stacking with other Intelligems discounts.",
  combinesWithShopify:
    "Set to true to allow stacking with native Shopify discounts.",
  shouldRejectCodes:
    "Set to true to reject manual discount codes when this offer is applied.",
  shippingDiscount:
    "Only relevant when discountApplicationType is 'freeShipping'.",
  requireSameItem:
    "For tiered discounts: set to true to require multiples of the same product toward thresholds.",
  subscriptionApplicationType:
    "Controls which purchase types this offer applies to: 'oneTime' (one-time purchases only), 'firstSub' (first subscription orders only), or 'oneTimeAndFirstSub' (both one-time and first subscription orders).",
} as const;

export const ExternalOfferDescriptions = {
  id: "Copy from GET response. Identifies which offer to update.",
  variationId: "Copy from GET response. Must match the parent variation's id.",
} as const;
